/* Colorblind themes */
const chartContainerId = '#hctag';

const fontsize = readUserPreference('fontsize');
const fontsizechart = readUserPreference('fontsize-chart');
const colorblind = readUserPreference('colorblind');
const patternfill = readUserPreference('patternfill');


/* set chart text */
if(fontsize) {    
    const r = document.querySelector(':root');
    r.style.setProperty('--fontsize', fontsize + '%');
}
if(fontsizechart) {
    const r = document.querySelector(':root');
    r.style.setProperty('--fontsize-chart', fontsizechart + '%');
}
if(colorblind) {
    setColorblindPalette(colorblind);
}


/*function getDefaultProperty(tagName, property) {
    // Create new element, get property value, remove element, return prop value:
    const ele = document.createElement(tagName);
    document.body.appendChild(ele);
    const styles = window.getComputedStyle(ele);
    const value = styles.getPropertyValue(property);
    document.body.removeChild(ele);
    return value;
}*/

function getThemeVars(themename) {
    switch (themename) {
        case 'achromatopsia':
            return {
                '--blue-scale-color-Blue100': '#a1d2f9',
                '--blue-scale-color-Blue200': '#86bff0',
                '--blue-scale-color-Blue300': '#6cabe0',
                '--blue-scale-color-Blue400': '#5199cc',
                '--blue-scale-color-Blue50': '#bce1fa',
                '--blue-scale-color-Blue500': '#3687c3',
                '--blue-scale-color-Blue600': '#1b75bb',
                '--blue-scale-color-Blue700': '#17639f',
                '--blue-scale-color-Blue800': '#135283',
                '--blue-scale-color-Blue900': '#0f4067',
                '--brand-color-ActiveBlue': '#08397a',
                '--brand-color-AliceBlue': '#f3f5f7',
                '--brand-color-Black': '#000000',
                '--brand-color-Blue': '#5571bf',
                '--brand-color-BlueGrey': '#a9b7c7',
                '--brand-color-BurntYellow': '#9a5b13',
                '--brand-color-DarkBlue': '#314375',
                '--brand-color-DarkGrey': '#171717',
                '--brand-color-DarkWhite': '#fafafa',
                '--brand-color-Green': '#1f7a1f',
                '--brand-color-Grey': '#a5a5a5',
                '--brand-color-IndicatorsBlue': '#064291',
                '--brand-color-IndicatorsYellow': '#c8a52d',
                '--brand-color-LightGrey': '#757575',
                '--brand-color-MedGrey': '#2c2c2c',
                //'--brand-color-ModalBlack': '#00000066',
                '--brand-color-ModalBlack': 'rgba(0, 0, 0, 0.40)',
                '--brand-color-Orange': '#d88540',
                '--brand-color-PaleGrey': '#6c757d',
                '--brand-color-Red': '#b3261e',
                '--brand-color-Teal': '#74bec3',
                '--brand-color-White': '#ffffff',

                '--sei2024-chart-color-Blue3': '#555555', //Medium-Dark Grey //--chart-color-0
                '--sei2024-chart-color-Red': '#a0a0a0', //Medium-Light Grey //--chart-color-1
                '--sei2024-chart-color-Yellow3': '#e0e0e0', //Near-white //--chart-color-2
                '--sei2024-chart-color-Green': '#000000', //Black //--chart-color-3
                '--sei2024-chart-color-Teal2': '#7a7a7a', //Medium Grey //--chart-color-4
                '--sei2024-chart-color-Purple4': '#2c2c2c', //Dark Grey //--chart-color-5
                '--sei2024-chart-color-Red2': '#c8c8c8', //Light Grey //--chart-color-6
                '--sei2024-chart-color-PaleGreen3': '#555555', //Medium-Dark Grey //--chart-color-7
                '--sei2024-chart-color-DeepBlue': '#a0a0a0', //Medium-Light Grey //--chart-color-8
                '--sei2024-chart-color-Purple3': '#2c2c2c'  //Dark Grey //--chart-color-9

                ,"--sei2024-monochromatic-chart-color-0": "#171717",
                "--sei2024-monochromatic-chart-color-1": "#454545",
                "--sei2024-monochromatic-chart-color-2": "#707070",
                "--sei2024-monochromatic-chart-color-3": "#939393",
                "--sei2024-monochromatic-chart-color-4": "#C6C2C2",
                "--sei2024-monochromatic-chart-color-5": "#F0F0F0",
                "--sei2024-monochromatic-label-color-0": "#FFFFFF",
                "--sei2024-monochromatic-label-color-1": "#FFFFFF",
                "--sei2024-monochromatic-label-color-2": "#FFFFFF",
                "--sei2024-monochromatic-label-color-3": "#000000",
                "--sei2024-monochromatic-label-color-4": "#000000",
                "--sei2024-monochromatic-label-color-5": "#000000"
            };
        case 'protanopia':
        case 'protanomaly':
            return {
                "--brand-color-White": "#ffffff",
                "--brand-color-DarkGrey": "#171717",
                "--brand-color-MedGrey": "#2c2c2c",
                "--brand-color-LightGrey": "#757575",
                "--brand-color-IndicatorsBlue": "#50389d",
                "--brand-color-Blue": "#5571bf",
                "--brand-color-Orange": "#cb7130",
                "--brand-color-BurntYellow": "#9a5b13",
                "--brand-color-Grey": "#a5a5a5",
                "--brand-color-Teal": "#74bec3",
                "--brand-color-Green": "#2c9a2c",
                "--brand-color-DarkBlue": "#314375",
                "--brand-color-Red": "#d0342c",
                "--brand-color-ActiveBlue": "#08397a",
                "--brand-color-PaleGrey": "#6c757d",
                "--brand-color-BlueGrey": "#a9b7c7",
                "--brand-color-IndicatorsYellow": "#c8a52d",
                "--brand-color-AliceBlue": "#f3f5f7",
                "--brand-color-Black": "#000000",
                "--brand-color-ModalBlack": "rgba(0, 0, 0, 0.40)",
                "--brand-color-DarkWhite": "#fafafa",
                "--sei2024-chart-color-Blue": "#2161ac",
                "--sei2024-chart-color-Red": "#fd0000",
                "--sei2024-chart-color-Yellow": "#eca222",
                "--sei2024-chart-color-LightGreen": "#b6bd3b",
                "--sei2024-chart-color-Teal": "#01aac3",
                "--blue-scale-color-Blue600": "#2161ac",
                "--blue-scale-color-Blue400": "#5199cc",
                "--blue-scale-color-Blue200": "#86bff0",
                "--blue-scale-color-Blue100": "#a1d2f9",
                "--blue-scale-color-Blue50": "#bce1fa",
                "--blue-scale-color-Blue800": "#50389d",
                "--sei2024-chart-color-Color0": "#1f8fd6",
                "--sei2024-chart-color-Color1": "#4a47b0",
                "--sei2024-chart-color-Color2": "#1cc65f",
                "--sei2024-chart-color-Color3": "#e85a2b",
                "--sei2024-chart-color-Color4": "#5d7aa6",
                "--sei2024-chart-color-Color5": "#c05ce0",
                "--sei2024-chart-color-Color6": "#22c7b0",
                "--sei2024-chart-color-Color7": "#e23a3a",
                "--sei2024-chart-color-Color8": "#f49c53",
                "--sei2024-chart-color-Color9": "#7fd1c9",
                "--sei2024-chart-color-Green": "#4c9e38",
                "--sei2024-chart-color-Purple": "#ff0097",
                "--sei2024-chart-color-LightBlue": "#00adff",
                "--sei2024-chart-color-Fuchsia": "#ff00b4",
                "--sei2024-chart-color-DarkBlue": "#101f57",
                "--sei2024-chart-color-Orange": "#b2984e",
                "--sei2024-chart-color-DarkTeal": "#00c1ba",
                "--sei2024-chart-color-Pink": "#ff19ff",
                "--sei2024-chart-color-Beige": "#b2a184",
                "--sei2024-chart-color-Blue3": "#3a78c0",
                "--sei2024-chart-color-Blue2": "#79a9e1",
                "--sei2024-chart-color-Blue1": "#abe7ff",
                "--sei2024-chart-color-Red3": "#ea1504",
                "--sei2024-chart-color-Red2": "#ff501a",
                "--sei2024-chart-color-Red1": "#ffb598",
                "--sei2024-chart-color-Yellow3": "#fab937",
                "--sei2024-chart-color-Yellow2": "#ffd76b",
                "--sei2024-chart-color-Yellow1": "#ffe9af",
                "--sei2024-chart-color-PaleGreen3": "#cdd94e",
                "--sei2024-chart-color-PaleGreen2": "#dce778",
                "--sei2024-chart-color-PaleGreen1": "#f1f6ba",
                "--sei2024-chart-color-Teal3": "#00cef1",
                "--sei2024-chart-color-Teal2": "#63e0f4",
                "--sei2024-chart-color-Teal1": "#8bf4ff",
                "--sei2024-chart-color-Green3": "#34c62a",
                "--sei2024-chart-color-Green2": "#b1d8ae",
                "--sei2024-chart-color-Green1": "#c0f7b6",
                "--sei2024-chart-color-Purple3": "#c493d1",
                "--sei2024-chart-color-Purple2": "#f4d2fd",
                "--sei2024-chart-color-Purple1": "#faedfd",
                "--sei2024-chart-color-LightBlue3": "#60d4ee",
                "--sei2024-chart-color-LightBlue2": "#53f5ff",
                "--sei2024-chart-color-LightBlue1": "#adfcff",
                "--sei2024-chart-color-Purple4": "#e2009c",
                "--sei2024-chart-color-Purple5": "#c466b9",
                "--sei2024-chart-color-Purple6": "#fbc0f2",
                "--sei2024-chart-color-Cobalt3": "#6f608d",
                "--sei2024-chart-color-Cobalt2": "#9f98ac",
                "--sei2024-chart-color-Cobalt1": "#cac1db",
                "--sei2024-chart-color-Orange3": "#ff006a",
                "--sei2024-chart-color-Orange2": "#d9bba0",
                "--sei2024-chart-color-Orange1": "#ede6d0",
                "--sei2024-chart-color-BlueGreen3": "#00b4be",
                "--sei2024-chart-color-BlueGreen2": "#00e3e4",
                "--sei2024-chart-color-BlueGreen1": "#00fffc",
                "--sei2024-chart-color-Pink3": "#ff60d2",
                "--sei2024-chart-color-Pink2": "#ff89d8",
                "--sei2024-chart-color-Pink1": "#edb4ec",
                "--sei2024-chart-color-Beige3": "#c9bda8",
                "--sei2024-chart-color-Beige2": "#d9d0c2",
                "--sei2024-chart-color-Beige1": "#ebe7e0",
                "--sei2024-chart-color-PaleBlue": "#f1effc",
                "--sei2024-chart-color-PaleRed": "#f3efe0",
                "--sei2024-chart-color-PaleYellow": "#f3fbe2",
                "--sei2024-chart-color-PaleGreen": "#f2f9ec",
                "--sei2024-chart-color-PaleTeal": "#eff3fa",
                "--sei2024-chart-color-PaleGreen4": "#edf6ec",
                "--sei2024-chart-color-PalePurple": "#fcf7ff",
                "--sei2024-chart-color-PaleHazel": "#f7f6ff",
                "--sei2024-chart-color-PaleFuchsia": "#f4eaf2",
                "--sei2024-chart-color-PalePurple1": "#f3f1fa",
                "--sei2024-chart-color-PaleBeige": "#f8f6f3",
                "--sei2024-chart-color-PaleTeal1": "#eff8ff",
                "--sei2024-chart-color-PalePink": "#f9f4f7",
                "--sei2024-chart-color-PaleTan": "#f3f4ef",
                "--sei2024-chart-color-DarkBlue1": "#50389d",
                "--sei2024-chart-color-DarkRed": "#d00000",
                "--sei2024-chart-color-DarkYellow": "#e07300",
                "--sei2024-chart-color-Slimer": "#97a011",
                "--sei2024-chart-color-DarkTeal1": "#008dcd",
                "--sei2024-chart-color-DarkGreen": "#008000",
                "--sei2024-chart-color-DarkPurple": "#6d267b",
                "--sei2024-chart-color-DeepBlue": "#408cef",
                "--sei2024-chart-color-DeepPurple": "#a4007e",
                "--sei2024-chart-color-DeepBeige": "#867c6a",
                "--sei2024-chart-color-DarkGray": "#454545",
                "--sei2024-chart-color-MediumGray": "#707070",
                "--sei2024-chart-color-Gray": "#939393",
                "--sei2024-chart-color-LightGray": "#c6c2c2",
                "--sei2024-chart-color-PaleGray": "#f0f0f0",
                "--sei2024-chart-color-OffWhite": "#f7f7f7"

                ,"--sei2024-monochromatic-chart-color-0": "#064291",
                "--sei2024-monochromatic-chart-color-1": "#2161AC",
                "--sei2024-monochromatic-chart-color-2": "#3A77B1",
                "--sei2024-monochromatic-chart-color-3": "#79A9E1",
                "--sei2024-monochromatic-chart-color-4": "#CCE4FF",
                "--sei2024-monochromatic-chart-color-5": "#ECF3FC",
                "--sei2024-monochromatic-label-color-0": "#FFFFFF",
                "--sei2024-monochromatic-label-color-1": "#FFFFFF",
                "--sei2024-monochromatic-label-color-2": "#FFFFFF",
                "--sei2024-monochromatic-label-color-3": "#000000",
                "--sei2024-monochromatic-label-color-4": "#000000",
                "--sei2024-monochromatic-label-color-5": "#000000"
                };
        case 'deuteranopia':
        case 'deuteranomaly':
            return {
                "--brand-color-White": "#ffffff",
                "--brand-color-DarkGrey": "#171717",
                "--brand-color-MedGrey": "#2c2c2c",
                "--brand-color-LightGrey": "#757575",
                "--brand-color-IndicatorsBlue": "#064291",
                "--brand-color-Blue": "#5571bf",
                "--brand-color-Orange": "#cb7130",
                "--brand-color-BurntYellow": "#9a5b13",
                "--brand-color-Grey": "#a5a5a5",
                "--brand-color-Teal": "#74bec3",
                "--brand-color-Green": "#2c9a2c",
                "--brand-color-DarkBlue": "#314375",
                "--brand-color-Red": "#d0342c",
                "--brand-color-ActiveBlue": "#08397a",
                "--brand-color-PaleGrey": "#6c757d",
                "--brand-color-BlueGrey": "#a9b7c7",
                "--brand-color-IndicatorsYellow": "#c8a52d",
                "--brand-color-AliceBlue": "#f3f5f7",
                "--brand-color-Black": "#000000",
                "--brand-color-ModalBlack": "rgba(0, 0, 0, 0.40)",
                "--brand-color-DarkWhite": "#fafafa",
                "--sei2024-chart-color-Blue": "#2161ac",
                "--sei2024-chart-color-Red": "#ff0000",
                "--sei2024-chart-color-Yellow": "#f59e00",
                "--sei2024-chart-color-LightGreen": "#69da03",
                "--sei2024-chart-color-Teal": "#00b4e2",
                "--blue-scale-color-Blue600": "#2161ac",
                "--blue-scale-color-Blue400": "#3a77b1",
                "--blue-scale-color-Blue200": "#79a9e1",
                "--blue-scale-color-Blue100": "#a1d2f9",
                "--blue-scale-color-Blue50": "#bce1fa",
                "--blue-scale-color-Blue800": "#064291",
                "--sei2024-chart-color-Color0": "#1f8fd6",
                "--sei2024-chart-color-Color1": "#6056c9",
                "--sei2024-chart-color-Color2": "#00b85e",
                "--sei2024-chart-color-Color3": "#f86c3a",
                "--sei2024-chart-color-Color4": "#7490c0",
                "--sei2024-chart-color-Color5": "#b55ee1",
                "--sei2024-chart-color-Color6": "#1cb8a3",
                "--sei2024-chart-color-Color7": "#ed413f",
                "--sei2024-chart-color-Color8": "#f6a55f",
                "--sei2024-chart-color-Color9": "#82d9d2",
                "--sei2024-chart-color-Green": "#00b100",
                "--sei2024-chart-color-Purple": "#d127d1",
                "--sei2024-chart-color-LightBlue": "#00a6eb",
                "--sei2024-chart-color-Fuchsia": "#c300a4",
                "--sei2024-chart-color-DarkBlue": "#2c1057",
                "--sei2024-chart-color-Orange": "#ff6b45",
                "--sei2024-chart-color-DarkTeal": "#00aea8",
                "--sei2024-chart-color-Pink": "#ff00ff",
                "--sei2024-chart-color-Beige": "#a3b284",
                "--sei2024-chart-color-Blue3": "#3a77b1",
                "--sei2024-chart-color-Blue2": "#79a9e1",
                "--sei2024-chart-color-Blue1": "#bde6ff",
                "--sei2024-chart-color-Red3": "#f20000",
                "--sei2024-chart-color-Red2": "#f66932",
                "--sei2024-chart-color-Red1": "#ffbba3",
                "--sei2024-chart-color-Yellow3": "#f1bc61",
                "--sei2024-chart-color-Yellow2": "#ffd76b",
                "--sei2024-chart-color-Yellow1": "#ffe99d",
                "--sei2024-chart-color-PaleGreen3": "#a6d578",
                "--sei2024-chart-color-PaleGreen2": "#c6e1ab",
                "--sei2024-chart-color-PaleGreen1": "#f2f4cb",
                "--sei2024-chart-color-Teal3": "#00cbe7",
                "--sei2024-chart-color-Teal2": "#17e0f4",
                "--sei2024-chart-color-Teal1": "#c4ebf1",
                "--sei2024-chart-color-Green3": "#5dc24c",
                "--sei2024-chart-color-Green2": "#addba3",
                "--sei2024-chart-color-Green1": "#ddedd9",
                "--sei2024-chart-color-Purple3": "#c686f5",
                "--sei2024-chart-color-Purple2": "#f6cbff",
                "--sei2024-chart-color-Purple1": "#f7edfe",
                "--sei2024-chart-color-LightBlue3": "#6ed0f2",
                "--sei2024-chart-color-LightBlue2": "#a4eeff",
                "--sei2024-chart-color-LightBlue1": "#ddf4fd",
                "--sei2024-chart-color-Purple4": "#ff4fec",
                "--sei2024-chart-color-Purple5": "#e946d8",
                "--sei2024-chart-color-Purple6": "#f1c5e9",
                "--sei2024-chart-color-Cobalt3": "#6f5c8d",
                "--sei2024-chart-color-Cobalt2": "#a292b9",
                "--sei2024-chart-color-Cobalt1": "#c9bfdb",
                "--sei2024-chart-color-Orange3": "#ff906f",
                "--sei2024-chart-color-Orange2": "#ffaa96",
                "--sei2024-chart-color-Orange1": "#ffd8d0",
                "--sei2024-chart-color-BlueGreen3": "#00d1c5",
                "--sei2024-chart-color-BlueGreen2": "#00e8e4",
                "--sei2024-chart-color-BlueGreen1": "#00e9e6",
                "--sei2024-chart-color-Pink3": "#ff32bc",
                "--sei2024-chart-color-Pink2": "#ff80dd",
                "--sei2024-chart-color-Pink1": "#ffb8e8",
                "--sei2024-chart-color-Beige3": "#c9bda8",
                "--sei2024-chart-color-Beige2": "#d9d0c2",
                "--sei2024-chart-color-Beige1": "#ebe7e0",
                "--sei2024-chart-color-PaleBlue": "#ccf7ff",
                "--sei2024-chart-color-PaleRed": "#fde7e1",
                "--sei2024-chart-color-PaleYellow": "#fff7d1",
                "--sei2024-chart-color-PaleGreen": "#f7fdcd",
                "--sei2024-chart-color-PaleTeal": "#b8f6f4",
                "--sei2024-chart-color-PaleGreen4": "#e6f9e1",
                "--sei2024-chart-color-PalePurple": "#fff4ff",
                "--sei2024-chart-color-PaleHazel": "#f4f9ff",
                "--sei2024-chart-color-PaleFuchsia": "#f6f0f1",
                "--sei2024-chart-color-PalePurple1": "#f2f4fa",
                "--sei2024-chart-color-PaleBeige": "#fcf5f4",
                "--sei2024-chart-color-PaleTeal1": "#cbffff",
                "--sei2024-chart-color-PalePink": "#fdf5f9",
                "--sei2024-chart-color-PaleTan": "#fff5ff",
                "--sei2024-chart-color-DarkBlue1": "#064291",
                "--sei2024-chart-color-DarkRed": "#cb0000",
                "--sei2024-chart-color-DarkYellow": "#bf831a",
                "--sei2024-chart-color-Slimer": "#8aa400",
                "--sei2024-chart-color-DarkTeal1": "#008bbe",
                "--sei2024-chart-color-DarkGreen": "#0a9106",
                "--sei2024-chart-color-DarkPurple": "#8f239f",
                "--sei2024-chart-color-DeepBlue": "#4188cb",
                "--sei2024-chart-color-DeepPurple": "#8a006f",
                "--sei2024-chart-color-DeepBeige": "#867c6a",
                "--sei2024-chart-color-DarkGray": "#454545",
                "--sei2024-chart-color-MediumGray": "#707070",
                "--sei2024-chart-color-Gray": "#939393",
                "--sei2024-chart-color-LightGray": "#c6c2c2",
                "--sei2024-chart-color-PaleGray": "#f0f0f0",
                "--sei2024-chart-color-OffWhite": "#f7f7f7"
                
                ,"--sei2024-monochromatic-chart-color-0": "#064291",
                "--sei2024-monochromatic-chart-color-1": "#2161AC",
                "--sei2024-monochromatic-chart-color-2": "#3A77B1",
                "--sei2024-monochromatic-chart-color-3": "#79A9E1",
                "--sei2024-monochromatic-chart-color-4": "#CCE4FF",
                "--sei2024-monochromatic-chart-color-5": "#ECF3FC",
                "--sei2024-monochromatic-label-color-0": "#FFFFFF",
                "--sei2024-monochromatic-label-color-1": "#FFFFFF",
                "--sei2024-monochromatic-label-color-2": "#FFFFFF",
                "--sei2024-monochromatic-label-color-3": "#000000",
                "--sei2024-monochromatic-label-color-4": "#000000",
                "--sei2024-monochromatic-label-color-5": "#000000"
            };
         case 'tritanopia':
         case 'tritanomaly':
            return {
                "--brand-color-White": "#ffffff",
                "--brand-color-DarkGrey": "#171717",
                "--brand-color-MedGrey": "#2c2c2c",
                "--brand-color-LightGrey": "#757575",
                "--brand-color-IndicatorsBlue": "#220091",
                "--brand-color-Blue": "#5571bf",
                "--brand-color-Orange": "#d88540",
                "--brand-color-BurntYellow": "#9a5b13",
                "--brand-color-Grey": "#a5a5a5",
                "--brand-color-Teal": "#74bec3",
                "--brand-color-Green": "#1f7a1f",
                "--brand-color-DarkBlue": "#314375",
                "--brand-color-Red": "#b3261e",
                "--brand-color-ActiveBlue": "#08397a",
                "--brand-color-PaleGrey": "#6c757d",
                "--brand-color-BlueGrey": "#a9b7c7",
                "--brand-color-IndicatorsYellow": "#b28b00",
                "--brand-color-AliceBlue": "#f3f5f7",
                "--brand-color-Black": "#000000",
                "--brand-color-ModalBlack": "rgba(0, 0, 0, 0.40)",
                "--brand-color-DarkWhite": "#fafafa",
                "--sei2024-chart-color-Blue": "#3313ac",
                "--sei2024-chart-color-Red": "#be3213",
                "--sei2024-chart-color-Yellow": "#eca222",
                "--sei2024-chart-color-LightGreen": "#bd9121",
                "--sei2024-chart-color-Teal": "#00c37b",
                "--blue-scale-color-Blue600": "#3313ac",
                "--blue-scale-color-Blue400": "#5199cc",
                "--blue-scale-color-Blue200": "#866fe1",
                "--blue-scale-color-Blue100": "#99c9f0",
                "--blue-scale-color-Blue50": "#aed6f5",
                "--blue-scale-color-Blue800": "#220091",
                "--sei2024-chart-color-Color0": "#1b9ceb",
                "--sei2024-chart-color-Color1": "#3e3aa3",
                "--sei2024-chart-color-Color2": "#1fd283",
                "--sei2024-chart-color-Color3": "#dc5930",
                "--sei2024-chart-color-Color4": "#5877a3",
                "--sei2024-chart-color-Color5": "#bb4ff0",
                "--sei2024-chart-color-Color6": "#3ad9c2",
                "--sei2024-chart-color-Color7": "#c93b34",
                "--sei2024-chart-color-Color8": "#e99d54",
                "--sei2024-chart-color-Color9": "#88e0dc",
                "--sei2024-chart-color-Green": "#489e33",
                "--sei2024-chart-color-Purple": "#8a4eaa",
                "--sei2024-chart-color-LightBlue": "#0011dc",
                "--sei2024-chart-color-Fuchsia": "#880373",
                "--sei2024-chart-color-DarkBlue": "#2c0957",
                "--sei2024-chart-color-Orange": "#ea694e",
                "--sei2024-chart-color-DarkTeal": "#025695",
                "--sei2024-chart-color-Pink": "#ea368e",
                "--sei2024-chart-color-Beige": "#b1ad98",
                "--sei2024-chart-color-Blue3": "#422eb1",
                "--sei2024-chart-color-Blue2": "#866fe1",
                "--sei2024-chart-color-Blue1": "#cce4e3",
                "--sei2024-chart-color-Red3": "#c75036",
                "--sei2024-chart-color-Red2": "#f3744d",
                "--sei2024-chart-color-Red1": "#fac0ae",
                "--sei2024-chart-color-Yellow3": "#f1bc61",
                "--sei2024-chart-color-Yellow2": "#ffd76b",
                "--sei2024-chart-color-Yellow1": "#ffe9af",
                "--sei2024-chart-color-PaleGreen3": "#d6bb76",
                "--sei2024-chart-color-PaleGreen2": "#e3d1a1",
                "--sei2024-chart-color-PaleGreen1": "#ebf3e6",
                "--sei2024-chart-color-Teal3": "#3ad59b",
                "--sei2024-chart-color-Teal2": "#7ce3bc",
                "--sei2024-chart-color-Teal1": "#bdf1de",
                "--sei2024-chart-color-Green3": "#7ebb6f",
                "--sei2024-chart-color-Green2": "#b5d8ad",
                "--sei2024-chart-color-Green1": "#dcedd8",
                "--sei2024-chart-color-Purple3": "#b893d1",
                "--sei2024-chart-color-Purple2": "#ebd3fd",
                "--sei2024-chart-color-Purple1": "#f6f7e1",
                "--sei2024-chart-color-LightBlue3": "#6068f6",
                "--sei2024-chart-color-LightBlue2": "#b7bbfb",
                "--sei2024-chart-color-LightBlue1": "#ddf4f2",
                "--sei2024-chart-color-Purple4": "#9f3f90",
                "--sei2024-chart-color-Purple5": "#bd9a6f",
                "--sei2024-chart-color-Purple6": "#e6dcbe",
                "--sei2024-chart-color-Cobalt3": "#70578d",
                "--sei2024-chart-color-Cobalt2": "#939a96",
                "--sei2024-chart-color-Cobalt1": "#bdc6bf",
                "--sei2024-chart-color-Orange3": "#f68d76",
                "--sei2024-chart-color-Orange2": "#fad7a6",
                "--sei2024-chart-color-Orange1": "#fef0cd",
                "--sei2024-chart-color-BlueGreen3": "#00b554",
                "--sei2024-chart-color-BlueGreen2": "#34d680",
                "--sei2024-chart-color-BlueGreen1": "#8fd1f4",
                "--sei2024-chart-color-Pink3": "#f071af",
                "--sei2024-chart-color-Pink2": "#f5ce99",
                "--sei2024-chart-color-Pink1": "#f9c5df",
                "--sei2024-chart-color-Beige3": "#c9c7b3",
                "--sei2024-chart-color-Beige2": "#d8d9c5",
                "--sei2024-chart-color-Beige1": "#e7eadb",
                "--sei2024-chart-color-PaleBlue": "#e6f3e6",
                "--sei2024-chart-color-PaleRed": "#fdf7db",
                "--sei2024-chart-color-PaleYellow": "#fcffe9",
                "--sei2024-chart-color-PaleGreen": "#f1f8ec",
                "--sei2024-chart-color-PaleTeal": "#ebf8f1",
                "--sei2024-chart-color-PaleGreen4": "#e8f6e9",
                "--sei2024-chart-color-PalePurple": "#f6fbea",
                "--sei2024-chart-color-PaleHazel": "#edf8ec",
                "--sei2024-chart-color-PaleFuchsia": "#f5f6df",
                "--sei2024-chart-color-PalePurple1": "#ebf3e7",
                "--sei2024-chart-color-PaleBeige": "#f9fbe8",
                "--sei2024-chart-color-PaleTeal1": "#e3feff",
                "--sei2024-chart-color-PalePink": "#fafde7",
                "--sei2024-chart-color-PaleTan": "#eff4e6",
                "--sei2024-chart-color-DarkBlue1": "#220091",
                "--sei2024-chart-color-DarkRed": "#8b1b03",
                "--sei2024-chart-color-DarkYellow": "#bf831a",
                "--sei2024-chart-color-Slimer": "#9f7919",
                "--sei2024-chart-color-DarkTeal1": "#00915a",
                "--sei2024-chart-color-DarkGreen": "#1e7b07",
                "--sei2024-chart-color-DarkPurple": "#5d277b",
                "--sei2024-chart-color-DeepBlue": "#000eaf",
                "--sei2024-chart-color-DeepPurple": "#5c2c00",
                "--sei2024-chart-color-DeepBeige": "#868475",
                "--sei2024-chart-color-DarkGray": "#454545",
                "--sei2024-chart-color-MediumGray": "#707070",
                "--sei2024-chart-color-Gray": "#939393",
                "--sei2024-chart-color-LightGray": "#c6c2c2",
                "--sei2024-chart-color-PaleGray": "#f0f0f0",
                "--sei2024-chart-color-OffWhite": "#f7f7f7"

                ,"--sei2024-monochromatic-chart-color-0": "#227B0D",
                "--sei2024-monochromatic-chart-color-1": "#4C9E38",
                "--sei2024-monochromatic-chart-color-2": "#81BB73",
                "--sei2024-monochromatic-chart-color-3": "#B7D8AF",
                "--sei2024-monochromatic-chart-color-4": "#DDEDD9",
                "--sei2024-monochromatic-chart-color-5": "#EFF6ED",
                "--sei2024-monochromatic-label-color-0": "#FFFFFF",
                "--sei2024-monochromatic-label-color-1": "#000000",
                "--sei2024-monochromatic-label-color-2": "#000000",
                "--sei2024-monochromatic-label-color-3": "#000000",
                "--sei2024-monochromatic-label-color-4": "#000000",
                "--sei2024-monochromatic-label-color-5": "#000000"
            };
        default:
            return {
                //default
                "--brand-color-White": "#ffffff",
                "--brand-color-DarkGrey": "#171717",
                "--brand-color-MedGrey": "#2c2c2c",
                "--brand-color-LightGrey": "#757575",
                "--brand-color-IndicatorsBlue": "#064291",
                "--brand-color-Blue": "#5571bf",
                "--brand-color-Orange": "#d88540",
                "--brand-color-BurntYellow": "#9a5b13",
                "--brand-color-Grey": "#a5a5a5",
                "--brand-color-Teal": "#74bec3",
                "--brand-color-Green": "#1f7a1f",
                "--brand-color-DarkBlue": "#314375",
                "--brand-color-Red": "#b3261e",
                "--brand-color-ActiveBlue": "#08397a",
                "--brand-color-PaleGrey": "#6c757d",
                "--brand-color-BlueGrey": "#a9b7c7",
                "--brand-color-IndicatorsYellow": "#c8a52d",
                "--brand-color-AliceBlue": "#f3f5f7",
                "--brand-color-Black": "#000000",
                "--brand-color-ModalBlack": "rgba(0, 0, 0, 0.40)",
                "--brand-color-DarkWhite": "#fafafa",
                "--sei2024-chart-color-Blue": "#2161ac",
                "--sei2024-chart-color-Red": "#be3213",
                "--sei2024-chart-color-Yellow": "#eca222",
                "--sei2024-chart-color-LightGreen": "#b6bd3b",
                "--sei2024-chart-color-Teal": "#01aac3",
                "--blue-scale-color-Blue600": "#2161ac",
                "--blue-scale-color-Blue400": "#3a77b1",
                "--blue-scale-color-Blue200": "#79a9e1",
                "--blue-scale-color-Blue100": "#cce4ff",
                "--blue-scale-color-Blue50": "#ecf3fc",
                "--blue-scale-color-Blue800": "#064291",
                "--sei2024-chart-color-Color0": "#2caffe",
                "--sei2024-chart-color-Color1": "#544fc5",
                "--sei2024-chart-color-Color2": "#00e272",
                "--sei2024-chart-color-Color3": "#fe6a35",
                "--sei2024-chart-color-Color4": "#6b8abc",
                "--sei2024-chart-color-Color5": "#d568fb",
                "--sei2024-chart-color-Color6": "#2ee0ca",
                "--sei2024-chart-color-Color7": "#fa4b42",
                "--sei2024-chart-color-Color8": "#feb56a",
                "--sei2024-chart-color-Color9": "#91e8e1",
                "--sei2024-chart-color-Green": "#4c9e38",
                "--sei2024-chart-color-Purple": "#8a4eaa",
                "--sei2024-chart-color-LightBlue": "#00a4dc",
                "--sei2024-chart-color-Fuchsia": "#880373",
                "--sei2024-chart-color-DarkBlue": "#101f57",
                "--sei2024-chart-color-Orange": "#ea694e",
                "--sei2024-chart-color-DarkTeal": "#039590",
                "--sei2024-chart-color-Pink": "#ea368e",
                "--sei2024-chart-color-Beige": "#b2a184",
                "--sei2024-chart-color-Blue3": "#3a77b1",
                "--sei2024-chart-color-Blue2": "#79a9e1",
                "--sei2024-chart-color-Blue1": "#cce4ff",
                "--sei2024-chart-color-Red3": "#c75036",
                "--sei2024-chart-color-Red2": "#f3744d",
                "--sei2024-chart-color-Red1": "#fac0ae",
                "--sei2024-chart-color-Yellow3": "#f1bc61",
                "--sei2024-chart-color-Yellow2": "#ffd76b",
                "--sei2024-chart-color-Yellow1": "#ffe9af",
                "--sei2024-chart-color-PaleGreen3": "#d2d686",
                "--sei2024-chart-color-PaleGreen2": "#e0e3ac",
                "--sei2024-chart-color-PaleGreen1": "#f2f3db",
                "--sei2024-chart-color-Teal3": "#4ec4d5",
                "--sei2024-chart-color-Teal2": "#89d8e3",
                "--sei2024-chart-color-Teal1": "#c4ebf1",
                "--sei2024-chart-color-Green3": "#81bb73",
                "--sei2024-chart-color-Green2": "#b7d8af",
                "--sei2024-chart-color-Green1": "#ddedd9",
                "--sei2024-chart-color-Purple3": "#b893d1",
                "--sei2024-chart-color-Purple2": "#ebd3fd",
                "--sei2024-chart-color-Purple1": "#f7edfe",
                "--sei2024-chart-color-LightBlue3": "#6ed0f6",
                "--sei2024-chart-color-LightBlue2": "#bdeafb",
                "--sei2024-chart-color-LightBlue1": "#ddf4fd",
                "--sei2024-chart-color-Purple4": "#9f3f90",
                "--sei2024-chart-color-Purple5": "#bd75b2",
                "--sei2024-chart-color-Purple6": "#e6cae1",
                "--sei2024-chart-color-Cobalt3": "#5c668d",
                "--sei2024-chart-color-Cobalt2": "#939bb9",
                "--sei2024-chart-color-Cobalt1": "#bfc7db",
                "--sei2024-chart-color-Orange3": "#f68d76",
                "--sei2024-chart-color-Orange2": "#fab0a0",
                "--sei2024-chart-color-Orange1": "#ffd8d0",
                "--sei2024-chart-color-BlueGreen3": "#00b5af",
                "--sei2024-chart-color-BlueGreen2": "#49d6d2",
                "--sei2024-chart-color-BlueGreen1": "#90f4f0",
                "--sei2024-chart-color-Pink3": "#f071af",
                "--sei2024-chart-color-Pink2": "#f5a2cb",
                "--sei2024-chart-color-Pink1": "#f9c5df",
                "--sei2024-chart-color-Beige3": "#c9bda8",
                "--sei2024-chart-color-Beige2": "#d9d0c2",
                "--sei2024-chart-color-Beige1": "#ebe7e0",
                "--sei2024-chart-color-PaleBlue": "#ecf3fc",
                "--sei2024-chart-color-PaleRed": "#fde7e1",
                "--sei2024-chart-color-PaleYellow": "#fff7e2",
                "--sei2024-chart-color-PaleGreen": "#f8f9ed",
                "--sei2024-chart-color-PaleTeal": "#ebf8fa",
                "--sei2024-chart-color-PaleGreen4": "#eff6ed",
                "--sei2024-chart-color-PalePurple": "#fbf7ff",
                "--sei2024-chart-color-PaleHazel": "#f4f9ff",
                "--sei2024-chart-color-PaleFuchsia": "#f6ebf4",
                "--sei2024-chart-color-PalePurple1": "#f2f4fa",
                "--sei2024-chart-color-PaleBeige": "#fcf5f4",
                "--sei2024-chart-color-PaleTeal1": "#e3fffe",
                "--sei2024-chart-color-PalePink": "#fdf5f9",
                "--sei2024-chart-color-PaleTan": "#f5f3f0",
                "--sei2024-chart-color-DarkBlue1": "#064291",
                "--sei2024-chart-color-DarkRed": "#8b1b03",
                "--sei2024-chart-color-DarkYellow": "#bf831a",
                "--sei2024-chart-color-Slimer": "#999f2f",
                "--sei2024-chart-color-DarkTeal1": "#007f91",
                "--sei2024-chart-color-DarkGreen": "#227b0d",
                "--sei2024-chart-color-DarkPurple": "#5d277b",
                "--sei2024-chart-color-DeepBlue": "#0283af",
                "--sei2024-chart-color-DeepPurple": "#5c004d",
                "--sei2024-chart-color-DeepBeige": "#867c6a",
                "--sei2024-chart-color-DarkGray": "#454545",
                "--sei2024-chart-color-MediumGray": "#707070",
                "--sei2024-chart-color-Gray": "#939393",
                "--sei2024-chart-color-LightGray": "#c6c2c2",
                "--sei2024-chart-color-PaleGray": "#f0f0f0",
                "--sei2024-chart-color-OffWhite": "#f7f7f7"
                
                ,"--sei2024-monochromatic-chart-color-0": "#064291",
                "--sei2024-monochromatic-chart-color-1": "#2161AC",
                "--sei2024-monochromatic-chart-color-2": "#3A77B1",
                "--sei2024-monochromatic-chart-color-3": "#79A9E1",
                "--sei2024-monochromatic-chart-color-4": "#CCE4FF",
                "--sei2024-monochromatic-chart-color-5": "#ECF3FC",
                "--sei2024-monochromatic-label-color-0": "#FFFFFF",
                "--sei2024-monochromatic-label-color-1": "#FFFFFF",
                "--sei2024-monochromatic-label-color-2": "#FFFFFF",
                "--sei2024-monochromatic-label-color-3": "#000000",
                "--sei2024-monochromatic-label-color-4": "#000000",
                "--sei2024-monochromatic-label-color-5": "#000000"
            };
        }
}

export function setChartTextSize(txtChartDefault) {
    const chartContainer = document.querySelector(chartContainerId);
    if(chartContainer) {
        chartContainer.parentElement.style.fontSize = txtChartDefault + 'px';
    }
    return true;
}
export function setColorblindPalette(val) {
    const theme_defn = getThemeVars(val) ;
    const r = document.querySelector(':root');
    Object.entries(theme_defn).forEach(([key, value]) => {
        r.style.setProperty(key, value);
    });
    return true;
}
export function readUserPreference(name) {
  let cookie = {};
  document.cookie.split(';').forEach(function(el) {
    let split = el.split('=');
    cookie[split[0].trim()] = split.slice(1).join("=");
  })
  return cookie[name];
}
export function setUserPreference(name, val) {
    if(['default','100'].includes(val)) {
        document.cookie = name + "=;0;path=/";
    } else {
        const d = new Date();
        d.setTime(d.getTime() + (365*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = name + "=" + val + ";" + expires + ";path=/";
    }    
    return true;
}